/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class anesthesia extends IceEntity {
  anesthesia_key: string = "";
  quantity_qualifier: string = "";
  quantity: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "ANESTHESIA";
  }
}
